const postUserImageRequest = async (data) => {
  const formData = new FormData();

  formData.append('file', data.file);

  return formData;
};

export default postUserImageRequest;
